import HTML from '../../../../../html'
import {ultraSelect} from '../../../../../html-components'

export class FilterValue {
    constructor(val, screenVal, asDefault = false) {
        this.value = val
        this.screenVal = screenVal || val
        this.default = asDefault
    }

    static create(val, screenVal, asDefault = false) {
        return new FilterValue(val, screenVal, asDefault)
    }
}


export class NeutralValue extends FilterValue {
    constructor(val = null, screenVal = 'Alla', asDefault = false) {
        super(val, screenVal, asDefault)
    }

    static create(val, screenVal, asDefault) {
        return new NeutralValue(val, screenVal, asDefault = false)
    }
}


export class FilterFieldMarkupBuilder {
    constructor(builder) {
        this.builder = builder
    }

    static create(builder) {
        return new FilterFieldMarkupBuilder(builder)
    }

    build(values, filterField) {
        return this.builder(values, filterField, HTML)
    }
}

export class FilterFieldTypesCollection {
    constructor() {
        this.collection = []
    }

    static create() { return new FilterFieldTypesCollection() }

    contains(name) {
        return this.collection.reduce((res, t) => {
            return res ? res : t.name === name
        }, false)
    }

    get(name) {
        if (this.contains(name)) {
            return this.collection.filter(t => t.name === name)[0].builder
        } else {
            return false
        }
    }

    add(name, builder) {
        if (!this.contains(name)) {
            this.collection.push({
                name: name,
                builder: builder,
            })
        }
        return this
    }

    remove(name) {
        this.collection = this.collection.filter(t => t.name !== name)
        return this
    }
}


export class FilterField {
    constructor(type = 'dropdown', name = 'Dropdown', useNeutral = true) {
        this.neutralValue = new NeutralValue()
        this.useNeutralValue = useNeutral
        this.values = useNeutral ? [this.neutralValue] : []
        this.type = type
        this.currentValue = this.values[0]
        this.name = name || 'unknown'
        this.markup = this.types.get(type).build(this.values, this)
        this.state = {}
        this.events = []
        this.filterExpression = data => data
    }

    static create(...args) {
        return new FilterField(...args)
    }

    static addType(name, func) {
        this.prototype.types.add(name, func(FilterFieldMarkupBuilder))
        return this
    }

    static removeType(name) {
        this.types.remove(name)
        return this
    }

    setNeutral(name, val = null) {
        this.neutralValue = NeutralValue.create(val, name)
        this.currentValue = this.neutralValue
        this.values = this.values.map(v => v instanceof NeutralValue ? this.neutralValue : v)
        this.updateMarkup()
        return this
    }

    removeNeutral() {
        this.values = this.values.filter(v => !(v instanceof NeutralValue))
        return this
    }

    fillValues(func) {
        var res = func(FilterValue)
        this.values = this.useNeutralValue ? [this.neutralValue] : []

        if (res instanceof Array) {
            this.values = this.values.concat(res)
        }

        this.neutralValue = this.neutralValue ? this.neutralValue : this.values[0]

        this.updateMarkup()
        return this
    }

    setCurrentValue(value) {
        this.currentValue = value
        return this
    }

    removeValue(value) {
        this.values = this.values.filter(v => v === value)
        return this
    }

    getValue() { return this.currentValue.value }

    getDisplayValue() { return this.currentValue.screenVal }

    updateMarkup() {
        this.markup = this.types.get(this.type).build(this.values, this)
        return this
    }

    getMarkup() { return this.markup }

    defineExpression(expr) {
        this.filterExpression = expr
        return this
    }

    getExpression() {
        if (this.currentValue instanceof NeutralValue) {
            return data => data
        }
        return this.filterExpression
    }

    mutateState(mutator) {
        this.state = mutator(this.state)
    }

    emit(name) {
        if (typeof this.events[name] !== 'undefined') {
            this.events[name].map(e => e(this))
        }
        return this
    }

    bindTo(name, callback) {
        if (typeof name !== 'string' || typeof callback !== 'function') {
            return this
        }
        if (typeof this.events[name] === 'undefined') {
            this.events[name] = []
        }
        this.events[name].push(callback)
        return this
    }

    unbind(name, callback) {
        if (typeof name !== 'string' || typeof callback !== 'function' ||
            typeof this.events[name] === 'undefined') {
            return this
        }
        if (this.events[name].contains(callback)) {
            this.events[name].splice(i, this.events[name].indexOf(callback))
        }
        return this
    }
}

FilterField.prototype.types = FilterFieldTypesCollection.create()


FilterField.addType('dropdown', Builder => {
    return Builder.create((values, field) => {
        return ultraSelect({
            buttonText: field.getDisplayValue(),
            list: values.map(v => {
                return {
                    attributes: { href: '#' },
                    classes: '',
                    content: v.screenVal,
                    onClick: (event, element, button, menu) => {
                        event.preventDefault()
                        field.setCurrentValue(v).emit('dofilter')

                        let buttonName = $(button).find('.u-select__button__name')

                        if (buttonName.length) {
                            buttonName.html(field.getDisplayValue())
                        } else {
                            button.innerHTML = field.getDisplayValue()
                        }
                    },
                }
            }),
        })
    })
})

FilterField.addType('checkboxes', Builder => {
    return Builder.create((values, field) => {
        return HTML('div')
            .classes('filter-checkboxes')
            .append(
                values.map(v => {
                    return HTML('label')
                        .classes('checkbox')
                        .attr({ title: v.screenVal })
                        .mutate(node => {
                            if (v.value && v.default) {
                                node.classList.add('selected')
                            }
                        })
                        .on('click', (event, element) => {
                            element.firstChild.checked
                            ? element.classList.add('selected')
                            : element.classList.remove('selected')
                        })
                        .append(HTML('span').content(v.screenVal).render())
                        .prepend(
                            HTML('input')
                                .attr({
                                    type: 'checkbox',
                                    name: 'objektStatus',
                                    value: v.screenVal,
                                })
                                .mutate(node => {
                                    if (v.value && v.default) {
                                        node.setAttribute('checked', 'true')
                                        field.mutateState(state => {
                                            if (!state || !(state instanceof Array)) {
                                                state = []
                                            }
                                            state.push(v.value)
                                            return state
                                        })
                                    }
                                })
                                .on('change', (e, element) => {
                                    field.mutateState(state => {
                                        if (element.checked) {
                                            if (!state.reduce((res, el) => res ? res : el === v.value, false)) {
                                                state.push(v.value)
                                            }
                                        } else {
                                            state = state.filter(val => val !== v.value)
                                        }
                                        return state
                                    })
                                    field.emit('dofilter')
                                })
                                .render(),
                        )
                }),
            )
            .render()
    })
})


export class FilterArray {
    constructor() {
        this.filters = []
    }

    static create(...args) { return new FilterArray(...args) }

    has(name) {
        return this.filters.reduce((res, f) => res ? res : f.name === name, false)
    }

    get(name) {
        return this.filters.reduce((res, f) => f.name === name ? f : res, this.filters[0]);
    }

    add(filter) {
        if (!this.has(filter)) {
            this.filters.push(filter);
        }
        return this;
    }

    remove(filter) {
        if (this.has(filter)) {
            this.filters = this.filters.filter(f => f.name !== filter.name);
        }
        return this;
    }

    getFilters() { return this.filters }

    applyFilters(data) {
        return this.filters.reduce((res, field) => {
            return res.filter(prop => field.getExpression()(prop, field.state));
        }, data);
    }
}
